import axios from "axios";
import { getServerUrl } from './getServerUrl';

export async function uploadModel(selectedFile: any,pipelineType : string) {
    const rootURL = getServerUrl()
    const URL = rootURL+"/randomforest/upload-pipeline";
    const storedToken = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("pipeline_file", selectedFile);
    formData.append("pipeline_type",pipelineType);
    const response = await axios.post<Pipeline>(
        URL,
        formData,
        {
            headers: {
                "Authorization": "Bearer " + storedToken,
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response.data;

    
}


